// Константы для арабских уроков

// Маппинг арабских букв на английские названия
export const LETTER_MAPPING = new Map([
  ["ا", "alif"], ["ب", "ba"], ["ت", "ta"], ["ث", "tha"],
  ["ج", "jeem"], ["ح", "hah"], ["خ", "khah"], ["د", "dal"],
  ["ذ", "thal"], ["ر", "ra"], ["ز", "zay"], ["س", "seen"],
  ["ش", "sheen"], ["ص", "sad"], ["ض", "dad"], ["ط", "tah"],
  ["ظ", "zah"], ["ع", "ain"], ["غ", "ghain"], ["ف", "fah"],
  ["ق", "qaf"], ["ك", "kaf"], ["ل", "lam"], ["م", "meem"],
  ["ن", "noon"], ["ه", "heh"], ["و", "waw"], ["ي", "ya"]
]);

// Слова для каждой буквы
export const WORDS_FOR_LETTER: Record<string, string[]> = {
  "alif": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "ba": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "ta": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "tha": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "jeem": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "hah": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "khah": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "dal": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "thal": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "ra": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "zay": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "seen": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "sheen": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "sad": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "dad": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "tah": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "zah": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "ain": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "ghain": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "fah": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "qaf": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "kaf": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "lam": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "meem": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "noon": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "heh": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "waw": ["bismillah", "allah", "alhamd", "rahman", "rahim"],
  "ya": ["bismillah", "allah", "alhamd", "rahman", "rahim"]
};

// Диакритические знаки
export const DIACRITICS = {
  fatha: 'َ',  // Фатха
  kasra: 'ِ',  // Касра  
  damma: 'ُ',  // Дамма
  sukun: 'ْ'   // Сукун
};

// Типы шагов урока
export const STEP_TYPES = {
  INTRODUCTION: 'introduction',
  LISTEN: 'listen',
  SYLLABLES: 'syllables',
  RECOGNITION: 'recognition',
  WRITING: 'writing',
  PRACTICE: 'practice',
  DRAWING: 'drawing',
  PRONUNCIATION: 'pronunciation',
  TAJWEED: 'tajweed',
  QURAN_EXAMPLE: 'quran_example',
  AYAH_SEARCH: 'ayah_search'
} as const;

// API endpoints
export const API_ENDPOINTS = {
  LESSONS: '/api/v1/arabic-lessons',
  LETTERS: '/api/v1/arabic-lessons/letters',
  WORDS: '/api/v1/arabic-lessons/letters',
  QURAN: '/api/v1/arabic-lessons/quran',
  ACHIEVEMENTS: '/api/v1/arabic-lessons/achievements',
  LEADERBOARD: '/api/v1/arabic-lessons/leaderboard',
  DAILY_CHALLENGE: '/api/v1/arabic-lessons/daily-challenge'
} as const;

// Цвета для рисования
export const DRAWING_COLORS = {
  USER_STROKE: '#000000',      // Черный для пользователя
  REFERENCE_STROKE: '#27ae60', // Зеленый для эталона
  BACKGROUND: '#fffef7',       // Светло-желтый фон
  GUIDE_LINE: '#ecf0f1'        // Серые направляющие
} as const;

// Настройки анимации
export const ANIMATION_SETTINGS = {
  DEFAULT_SPEED: 1,
  MIN_SPEED: 0.5,
  MAX_SPEED: 3,
  STROKE_WIDTH: 7,
  GUIDE_LINE_WIDTH: 2
} as const;

// Настройки записи аудио
export const AUDIO_SETTINGS = {
  MIME_TYPE: 'audio/webm;codecs=opus',
  VOLUME: 0.8,
  LOAD_TIMEOUT: 10000, // 10 секунд
  RECORDING_TIMEOUT: 30000 // 30 секунд максимум
} as const;

// Настройки распознавания речи
export const SPEECH_RECOGNITION_SETTINGS = {
  LANGUAGE: 'ar-SA',
  CONTINUOUS: false,
  INTERIM_RESULTS: false,
  MAX_ALTERNATIVES: 3
} as const;

// Пороги для оценки рисования
export const DRAWING_THRESHOLDS = {
  MIN_SIMILARITY: 0.3,
  MIN_COVERAGE: 0.1,
  MIN_STROKES: 1,
  PROXIMITY_THRESHOLD: 5
} as const;

// Веса для алгоритма оценки рисования
export const DRAWING_WEIGHTS = {
  SIMILARITY: 0.4,
  STROKE_COUNT: 0.2,
  TOTAL_POINTS: 0.2,
  COVERAGE: 0.15,
  CENTERED: 0.05
} as const;

// Сообщения об ошибках
export const ERROR_MESSAGES = {
  MICROPHONE_ACCESS: 'Не удалось получить доступ к микрофону. Проверьте разрешения браузера.',
  AUDIO_PLAYBACK: 'Не удалось воспроизвести аудио. Проверьте подключение к интернету.',
  LESSON_LOAD: 'Не удалось загрузить урок',
  AYAH_LOAD: 'Не удалось загрузить аят',
  WORDS_LOAD: 'Не удалось загрузить слова',
  SPEECH_RECOGNITION: 'Распознавание речи не поддерживается в этом браузере',
  DRAWING_CANVAS: 'Не удалось инициализировать canvas для рисования'
} as const;

// Сообщения об успехе
export const SUCCESS_MESSAGES = {
  RECORDING_COMPLETE: 'Запись завершена',
  LESSON_COMPLETE: 'Урок завершен!',
  ACHIEVEMENT_UNLOCKED: 'Достижение разблокировано!',
  HIGH_SCORE: 'Отличный результат!'
} as const;
